<template>
    <md-table-row class="detail-row">
        <td :colspan="columnSize">
            <div class="detail-div" v-if="tableData.length > 0">
                <md-card v-for="(items, index) in tableData" :key="index">
                    <md-card-content
                        v-if="items.length > 0"
                        class="pt-2 pb-2"
                        :key="`table${index}`"
                    >
                        <md-table-toolbar>
                            <div class="md-toolbar-section-start">
                                <h2 class="md-title">
                                    {{ items[0].title }}
                                </h2>
                                <div
                                    class="collapse-button"
                                    @click="showTable(index)"
                                >
                                    <i
                                        class="fa fa-window-minimize"
                                        aria-hidden="true"
                                        v-show="opened.includes(index)"
                                    ></i>
                                    <i
                                        class="fa fa-window-maximize"
                                        aria-hidden="true"
                                        v-show="!opened.includes(index)"
                                    ></i>
                                </div>
                            </div>
                        </md-table-toolbar>
                        <md-table
                            id="master-detail-table"
                            v-model="tableData"
                            md-card
                            @md-selected="emitSelectedItems"
                            v-show="opened.includes(index)"
                        >
                            <md-table-row class="heads">
                                <th
                                    v-for="(head, headIndex) in items[0].heads"
                                    :key="`headIndex-${headIndex}`"
                                    :colspan="head.size"
                                >
                                    {{ head.head }}
                                </th>
                            </md-table-row>
                            <md-table-row
                                class="sub-heads"
                                v-if="items[0].subHeads"
                            >
                                <th
                                    v-for="(subHead, subHeadKey) in items[0]
                                        .subHeads"
                                    :key="`subHead-${subHeadKey}`"
                                    :colspan="subHead.size"
                                >
                                    {{ subHead.subHead }}
                                </th>
                            </md-table-row>
                            <md-table-row
                                v-for="(row, rowKey) in items"
                                @mouseenter="actionVisible = row.id"
                                @mouseleave="actionVisible = null"
                                :key="`row${rowKey}`"
                            >
                                <md-table-cell
                                    v-for="(key, keyIndex) in Object.keys(
                                        row.subHeads
                                    )"
                                    :md-label="key"
                                    :md-sort-by="key"
                                    :key="keyIndex"
                                    :style="
                                        row.columnsToColor &&
                                        row.columnsToColor.columns.some(
                                            column => column === key
                                        )
                                            ? row.columnsToColor.style
                                            : ''
                                    "
                                >
                                    <StatusBar
                                        v-if="key === 'status'"
                                        :typeBar="'circle'"
                                        :data="row[key]"
                                        :hasData="false"
                                    />
                                    <div v-else>
                                        {{ row.rowContent[key] }}
                                        <div v-if="key === 'productId'">
                                            <v-icon
                                                v-if="row.is_guaranteed_stock"
                                                title="Garantido"
                                                style="color:var(--blue-400)"
                                            >
                                                mdi-lock
                                            </v-icon>
                                            <v-icon
                                                v-if="row.is_favorite"
                                                title="Favorito"
                                                style="color:var(--yellow-400)"
                                            >
                                                mdi-star
                                            </v-icon>
                                            <span
                                                title="Novo"
                                                class="new_product"
                                                v-if="row.is_new"
                                            >
                                                <img
                                                    class="img_new_product"
                                                    src="/img/new-product.png"
                                                    alt="Novo Produto"
                                                    title="Novo Produto"
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </md-table-cell>
                                <md-table-cell
                                    class="td-actions"
                                    v-if="row.buttons"
                                >
                                    <div v-show="actionVisible == row.id">
                                        <md-button
                                            class="md-just-icon md-primary md-simple"
                                            @click="
                                                emitEvent(
                                                    'submit',
                                                    row,
                                                    'to submit'
                                                )
                                            "
                                            v-if="!row.buttons.submit.disabled"
                                        >
                                            <md-icon>check</md-icon>
                                        </md-button>
                                        <md-button
                                            class="md-just-icon md-warning md-simple"
                                            @click="
                                                emitEvent(
                                                    'edit',
                                                    row,
                                                    'to edit'
                                                )
                                            "
                                            v-if="!row.buttons.edit.disabled"
                                        >
                                            <md-icon>edit</md-icon>
                                        </md-button>
                                        <md-button
                                            class="md-just-icon md-danger md-simple"
                                            @click="
                                                emitEvent(
                                                    'reject',
                                                    row,
                                                    'to reject'
                                                )
                                            "
                                            v-if="!row.buttons.reject.disabled"
                                        >
                                            <md-icon>close</md-icon>
                                        </md-button>
                                    </div>
                                </md-table-cell>
                            </md-table-row>
                        </md-table>
                    </md-card-content>
                </md-card>
            </div>
            <span class="md-body-2" v-else>Nenhum item encontrado</span>
        </td>
    </md-table-row>
</template>

<script>
import StatusBar from '@/components/Bars/StatusBar.vue'
import Utils from '@/utils'

const attributesToOmit = [
    'buttons',
    'columns',
    'title',
    'heads',
    'subHeads',
    'rowContent',
    'columnsToColor'
]

export default {
    name: 'master-detail',
    components: { StatusBar },
    props: ['content', 'columnSize'],
    data() {
        return {
            actionVisible: null,
            opened: [0, 1]
        }
    },
    computed: {
        tableData() {
            let data = []
            Object.values(this.content).forEach(item => {
                if (item.length > 0) {
                    data.push(
                        item.map(table => {
                            let heads = []
                            let subHeads = {}
                            let hasButtons = table.buttons ? true : false
                            const { columns, ...rest } = table

                            columns.forEach((column, index) => {
                                let expandLastSubhead =
                                    hasButtons && columns.length - 1 == index
                                let choosedHead = {}

                                if (column.subHead) {
                                    const head = {
                                        head: column.head,
                                        size: expandLastSubhead
                                            ? Object.keys(column.subHead)
                                                  .length + 1
                                            : Object.keys(column.subHead).length
                                    }

                                    heads.push(head)

                                    choosedHead = column.subHead
                                } else {
                                    choosedHead = column.head
                                }

                                Object.entries(choosedHead).forEach(value => {
                                    subHeads[`${value[0]}`] = {
                                        subHead: value[1],
                                        size: expandLastSubhead ? 2 : 1
                                    }
                                })
                            })
                            return {
                                ...rest,
                                heads,
                                subHeads
                            }
                        })
                    )
                }
            })

            return data
        }
    },
    methods: {
        emitEvent(event, item, action) {
            this.$emit(event, _.omit(item, attributesToOmit), action)
        },
        showTable(id) {
           Utils.toggle(id, this.opened)
        },

        emitSelectedItems(items) {
            let selectedItems = items.map(item => {
                return _.omit(item, attributesToOmit)
            })
            this.$emit('select', selectedItems)
        }
    }
}
</script>

<style scoped>
.detail-row {
    cursor: default;
}
.detail-div {
    padding: 0px 20px;
}
.md-table-toolbar {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
    width: 100%;
    margin-left: 20px;
}

.md-table-row {
    text-align: center;
}

#master-detail-table {
    width: 98%;
    margin: 20px auto;
}

.heads {
    text-align: center !important;
    pointer-events: none;
}

.heads,
.sub-heads {
    pointer-events: none;
}
.heads {
    font-size: 14px;
}
.sub-heads {
    font-size: 13px;
}

th {
    border: 1px solid #eee;
}
.md-table-cell {
    font-size: 12px;
}

th {
    border: 1px solid #eee;
}

.md-table-cell {
    font-size: 12px;
}

.sub-head {
    font-size: 0.75rem;
    color: #595959;
}

.new_product {

    height: 20px;
    animation: animateProduct 2s linear infinite;
    overflow: hidden;
    top: 1px;
    right: 2px;
}

.img_new_product {
    max-width: 1.8rem !important;
}

.collapse-button {
    text-align: right;
}
</style>
